import {
  SEARCH_COLLECTORS,
  SEARCH_COLLECTORS_SUCCESS,
  AUTOCOMPLETE_COLLECTORS,
  AUTOCOMPLETE_COLLECTORS_SUCCESS,
  GET_COLLECTOR,
  GET_COLLECTOR_SUCCESS,
  GET_COLLECTOR_ERROR,
  GET_COLLECTOR_CLIENTS,
  GET_COLLECTOR_CLIENTS_SUCCESS,
  ADD_CLIENT_TO_COLLECTOR,
  ADD_CLIENT_TO_COLLECTOR_SUCCESS,
  REMOVE_CLIENT_FROM_COLLECTOR,
  REMOVE_CLIENT_FROM_COLLECTOR_SUCCESS,
  UPDATE_COLLECTOR_RECIPIENTS,
  UPDATE_COLLECTOR_RECIPIENTS_SUCCESS,
  UPDATE_COLLECTOR_RECIPIENTS_ERROR,
} from '../constants/ActionsTypes'

export const searchCollectors = (params) => {
  return {
    type: SEARCH_COLLECTORS,
    payload: params,
  }
}

export const searchCollectorsSuccess = (data) => {
  return {
    type: SEARCH_COLLECTORS_SUCCESS,
    payload: data,
  }
}

export const autocompleteCollectors = (params) => {
  return {
    type: AUTOCOMPLETE_COLLECTORS,
    payload: params,
  }
}

export const autocompleteCollectorsSuccess = (data) => {
  return {
    type: AUTOCOMPLETE_COLLECTORS_SUCCESS,
    payload: data,
  }
}

export const getCollector = (id) => {
  return {
    type: GET_COLLECTOR,
    payload: id,
  }
}

export const getCollectorSuccess = (data) => {
  return {
    type: GET_COLLECTOR_SUCCESS,
    payload: data,
  }
}

export const getCollectorError = (error) => {
  return {
    type: GET_COLLECTOR_ERROR,
    payload: error,
  }
}

export const getCollectorClients = (collectorId, params) => {
  return {
    type: GET_COLLECTOR_CLIENTS,
    payload: { collectorId, params },
  }
}

export const getCollectorClientsSuccess = (data) => {
  return {
    type: GET_COLLECTOR_CLIENTS_SUCCESS,
    payload: data,
  }
}

export const addClientToCollector = (collectorId, clientId) => {
  return {
    type: ADD_CLIENT_TO_COLLECTOR,
    payload: { collectorId, clientId },
  }
}

export const addClientToCollectorSuccess = (data) => {
  return {
    type: ADD_CLIENT_TO_COLLECTOR_SUCCESS,
    payload: data,
  }
}

export const removeClientFromCollector = (collectorId, clientId) => {
  return {
    type: REMOVE_CLIENT_FROM_COLLECTOR,
    payload: { collectorId, clientId },
  }
}

export const removeClientFromCollectorSuccess = (data) => {
  return {
    type: REMOVE_CLIENT_FROM_COLLECTOR_SUCCESS,
    payload: data,
  }
}

export const updateCollectorRecipients = (params) => {
  return {
    type: UPDATE_COLLECTOR_RECIPIENTS,
    payload: params,
  }
}

export const updateCollectorRecipientsSuccess = () => {
  return {
    type: UPDATE_COLLECTOR_RECIPIENTS_SUCCESS,
  }
}

export const updateCollectorRecipientsError = (error) => {
  return {
    type: UPDATE_COLLECTOR_RECIPIENTS_ERROR,
    payload: error,
  }
}
